import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

@Injectable()
export class MatPaginatorIntlService extends MatPaginatorIntl {
  public constructor(private readonly translateService: TranslateService) {
    super();
    this.translate();
  }

  public getRangeLabel = function (page: number, pageSize: number, length: number): string {
    if (length === Infinity) {
      return null;
    }

    const labelOf = this.translateService.instant(TranslationKeys.GeneraDataPagerOf);
    const labelItems = this.translateService.instant(TranslationKeys.GeneraDataPagerItems);

    if (length === 0 || pageSize === 0) {
      return `0 ${labelOf} ${length} ${labelItems}`;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} ${labelOf} ${length} ${labelItems}`;
  };

  private translate(): void {
    this.itemsPerPageLabel = this.translateService.instant(TranslationKeys.GeneraDataPagerItemsPerPage);
    this.nextPageLabel = this.translateService.instant(TranslationKeys.GeneraDataPagerNextPage);
    this.previousPageLabel = this.translateService.instant(TranslationKeys.GeneraDataPagerPreviousPage);
    this.firstPageLabel = this.translateService.instant(TranslationKeys.GeneraDataPagerFirstPage);
    this.lastPageLabel = this.translateService.instant(TranslationKeys.GeneraDataPagerLastPage);

    this.changes.next();
  }
}
